import { getRequest, type IValidatedResponse } from '../../httpClient';
import type { IGetProgressCardsV1Request } from './get-progress-cards-v1-request';
import {
  getProgressCardsV1ResponseSchema,
  type IGetProgressCardsV1Response,
} from './get-progress-cards-v1-response';

export async function getProgressCardsV1Api(
  params?: IGetProgressCardsV1Request,
): Promise<IValidatedResponse<IGetProgressCardsV1Response>> {
  const query = new URLSearchParams();
  if (params?.bucket) {
    query.set('bucket', params.bucket);
  }
  if (params?.level != null) {
    query.set('level', String(params.level));
  }
  if (params?.state) {
    query.set('state', params.state);
  }
  if (params?.cefr) {
    query.set('cefr', params.cefr);
  }
  if (params?.cursor) {
    query.set('cursor', params.cursor);
  }
  if (params?.limit) {
    query.set('limit', String(params.limit));
  }
  if (params?.dueFrom != null) {
    query.set('dueFrom', String(params.dueFrom));
  }
  if (params?.dueTo != null) {
    query.set('dueTo', String(params.dueTo));
  }

  const qs = query.toString();

  return getRequest<IGetProgressCardsV1Response>({
    path: qs ? `/progress/cards/v1?${qs}` : '/progress/cards/v1',
    schema: getProgressCardsV1ResponseSchema,
  });
}
